<template>
  <v-dialog ref="dateDialog" :value="proposeDialogValue" @input="$emit('proposeClosed')" max-width="325px" persistent>
    <v-card>
      <v-card-title class="title">
        Choose 3 Dates
      </v-card-title>
      <v-card-text class="pb-0">
        <p v-if="post">
          Scheduled: <strong>{{post.postDate}}{{post.postDateEnd ? `&nbsp; to ${post.postDateEnd}` : ''}}</strong>
        </p>
        <p v-if="post && post.requestDate">
          Requested Date: <strong>{{post.requestDate}}</strong>
        </p>
        <v-date-picker 
        v-model="submissionReview.propose_dates" 
        scrollable 
        multiple
        :allowed-dates="allowedDates">
          <v-spacer></v-spacer>
          <v-btn text color="secondary" @click="close">Cancel</v-btn>
          <v-btn
            text
            color="secondary"
            @click="saveChangeDate"
            @click.stop="askDate = false"
          >OK</v-btn>
        </v-date-picker>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="true"
          loader="bars"
          background-color="#000"
          color="secondary"
          width.number="180"
          height.number="180"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
// import config from '@/config';
// import { mapState, mapGetters } from 'vuex';
// import moment from 'moment'
import { mapState } from 'vuex';
import DatePicker from '@/components/scoped/custom/DatePicker'
import Loading from 'vue-loading-overlay';
export default {
  name: 'ProposeDateModal',
  components: {
    DatePicker,
    Loading
  },
  props: {
    post: Object,
    proposeDialogValue: Boolean
  },
  data () {
    return {
      isLoading: false,
      submissionReview: {
        propose_dates: []
      }
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      postUpdateStatus: state => state.post.updated
    })
  },
  methods: {
    resetForm() {
      this.submissionReview = {
        propose_dates: []
      }
      this.valid = true
    },
    close() {
      this.proposeDialogValue = false
      this.$emit('proposeClosed')
    },
    async saveChangeDate() {
      this.$refs.dateDialog.save(this.submissionReview.propose_dates)
      // let saveProposeDates = this.submissionReview.propose_dates.map(p => Object.assign({}, {
      //   value: p,
      //   selected: false
      // }))
      let saveData = [
        {
          id: this.post._id,
          propose_dates: this.submissionReview.propose_dates
        }
      ]
      await this.$store.dispatch('post/updatePostByIds', saveData)
      if (this.postUpdateStatus) {
        // Show success message
        this.$swal({
          text: 'Proposed Dates sent to Client',
          type: 'success'
        });
        await this.$store.dispatch('post/sendProposeDateClientEmail', {
          id: this.post._id,
          appLink: window.location.protocol + '//' + window.location.host + '/clients/posts?id=' + this.post._id
        })
      }
    },
    allowedDates(val) {
      let proposeDates = this.submissionReview.propose_dates
      if (Array.isArray(proposeDates) && proposeDates.length === 3) {
        return proposeDates.includes(val)
      }
      return true
    }
  },
  watch: {
  }
};
</script>
<style scoped>
  .choose-date {
    position: absolute;
    margin-top: 10px;
    z-index: 1;
    color: #fff;
    font-weight: 500;
    margin-left: 175px;
  }
</style>



// WEBPACK FOOTER //
// ProposeDateModal.vue?3c98d755